import { createFile, createFolder, deleteFile, deleteFolder, fetchPersonalDrives, fetchSinglePersonalDrive, renameFile, renameFolder } from "../../../../api/businessAndEnterprise/driveApi";
import { useEffect, useState, useRef, useCallback, useContext } from "react";
import ReactNotifications, { showApiErrors } from "../../../common/reactNotifications/ReactNotifications";
import * as utilConstants from "../../../../utils/constants/utilsConstants";
import validateFields from "../../../ValidationChecker";
import CommonModal from "../../../common/commonModal/CommonModal";
import DeleteModal from "../../../common/commonModal/DeleteModal";
import folderImg from "../../../../assets/images/folder_dark.png";
import { useLocation, useNavigate } from 'react-router-dom';

import Menu from "./Menu";
import NoData from "./NoData";
import AddButtonMenu from "./AddButtonMenu";
import { FaFileAlt, FaFileExport, FaHome, FaTrash } from "react-icons/fa";
import Sheet from "../Sheet";
import Context from "../../../../context/Context";
import { downloadToCsv } from "../../../../api/financeApi";
import { bulkDeleteSheets } from "../../../../api/businessAndEnterprise/sheetApi";
import { formatFileSize, timeAgo } from "../../../common";
import { BiChevronRight } from "react-icons/bi";
import FilterComponent, { buildQueryParams } from "./FilterComponent";


const defaultModalData = {
    folders: { name: "" },
    files: { title: "", is_shared: false },
};

const formFields = {
    folders: [
        { name: "name", type: "text", placeholder: "Folder Name", required: true },
    ],
    files: [
        { name: "title", type: "text", placeholder: "File Title", required: true },
        { name: "is_shared", type: "checkbox", label: "Shared?", required: false },
    ],
};

const apiMap = {
    folders: {
        create: createFolder,
        update: renameFolder,
    },
    files: {
        create: createFile,
        update: renameFile,
    },
};

const PersonalDrive = ({
    id = null,
    headingTitle = "Personal Drive",
    fetchApiFunc = fetchPersonalDrives,
    fetchSingleDriveApiFunc = fetchSinglePersonalDrive,
    isAddEdit = true
}) => {
    const [activeTab, setActiveTab] = useState("folders");
    const [currentFolderId, setCurrentFolderId] = useState(null);
    const [breadcrumb, setBreadcrumb] = useState([{ id: null, name: "Home" }]);

    const [teamName, setTeamName] = useState("");

    const [folderPage, setFolderPage] = useState(1);
    const [folders, setFolders] = useState([]);
    const [folderCount, setFolderCount] = useState(0);

    const [sheetPage, setSheetPage] = useState(1);
    const [sheets, setSheets] = useState([]);
    const [sheetCount, setSheetCount] = useState(0);
    const [loadingSheetId, setLoadingSheetId] = useState(null);

    const [loading, setLoading] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [modalMode, setModalMode] = useState("");
    const [modalData, setModalData] = useState(defaultModalData[activeTab]);
    const [errors, setErrors] = useState({});
    const [selectedIds, setSelectedIds] = useState([]);
    const [isSaving, setIsSaving] = useState(false);

    const loaderRef = useRef(null);
    const tableRef = useRef();
    const { user, setCurrentSheetIndex, setPageTitle } = useContext(Context);

    const location = useLocation();
    const navigate = useNavigate();
    const [filters, setFilters] = useState({
        type: "all",
        date: null,
    });
    const lastFetchRef = useRef({
        folderId: null,
        filtersKey: null,
    });

    const filterKey = JSON.stringify({
        sortBy: filters.sortBy,
        type: filters.type,
        date: filters.date,
        search: filters.search,
    });



    const handleOpenModal = (mode, rowData = {}) => {
        setModalMode(mode);
        setModalData(mode === "add" ? defaultModalData[activeTab] : rowData);
        setErrors({});
        setShowModal(true);
        setIsSaving(false);
    };

    const folderColumns = [
        { accessor: "name", header: "Folder Name" }
    ];

    const fileColumns = [
        { accessor: 'title', header: 'File Title' },
        {
            accessor: 'is_shared',
            header: <span style={{ color: '#dc3545' }}>
                {user?.role === "Company Head"
                    ? "Share with all teams with View & Edit access?"
                    : ["Team Head", "Member"].includes(user?.role)
                        ? "Share with my team with View & Edit access?"
                        : "Share?"}
            </span>,
            type: 'checkbox'
        },
    ];

    const handleSave = () => {
        if (isSaving) return;

        const { isValid, errors } = validateFields(modalData, formFields[activeTab]);

        if (isValid) {
            setIsSaving(true);
            setErrors({});
            const apiFuncs = apiMap[activeTab];

            let lastCrumb;
            let payload = { ...modalData };
            if (breadcrumb.length > 0) {
                lastCrumb = breadcrumb[breadcrumb?.length - 1];
                if (lastCrumb?.id) {
                    if (activeTab === "folders") {
                        payload.parent = lastCrumb.id;
                    } else if (activeTab === "files") {
                        payload.folder = lastCrumb.id;
                    }
                }
            }

            if (modalMode === "add") {
                apiFuncs.create(payload, (res) => {
                    setIsSaving(false);
                    if (res?.status === true) {
                        ReactNotifications(res?.message || res?.data?.message, utilConstants.sucessState200);
                        !lastCrumb?.id ? resetAndFetch(activeTab) : resetAndFetchFoldersAndSheets(lastCrumb?.id)
                        setShowModal(false);
                    } else if (res?.data?.errors) {
                        setErrors(res?.data?.errors);
                    } else {
                        setShowModal(false);
                        //  ReactNotifications(res?.message || res?.data?.message, utilConstants.getErrorStatus);
                        showApiErrors(res)
                    }
                });
            } else if (modalMode === "edit") {
                apiFuncs.update(modalData.id, modalData, (res) => {
                    setIsSaving(false);
                    if (res?.status === true) {
                        ReactNotifications(res?.message || res?.data?.message, utilConstants.sucessState200);
                        !lastCrumb?.id ? resetAndFetch(activeTab) : resetAndFetchFoldersAndSheets(lastCrumb?.id)
                        setShowModal(false);
                    } else if (res?.data?.errors) {
                        setErrors(res?.data?.errors);
                    } else {
                        //  ReactNotifications(res?.message || res?.data?.message, utilConstants.getErrorStatus);
                        showApiErrors(res)
                    }
                });
            }
        } else {
            setErrors(errors);
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const updatedData = {
            ...modalData,
            [name]: type === 'checkbox' ? checked : value
        };
        setModalData(updatedData);
        const { errors } = validateFields(modalData, formFields[activeTab]);
        setErrors(errors);
    };


    const fetchDrives = (page, type) => {
        if (loading) return;
        setLoading(true);

        const payload = {
            ...(type === "folders" ? { folders_page: page } : { sheets_page: page }),
            ...(id ? { team_id: id } : {}),
            ...buildQueryParams(filters, activeTab),

        };

        if (filters.search) payload.search = filters.search;


        fetchApiFunc(payload, (response) => {
            if (response?.status === true) {
                response?.team_name && setTeamName(response?.team_name);
                if (type === "folders") {
                    setFolderCount(response?.folders?.count);
                    setFolders((prev) => [...prev, ...(response?.folders?.data || [])]);
                } else {
                    setSheetCount(response?.sheets?.count);
                    setSheets((prev) => [...prev, ...(response?.sheets?.data || [])]);
                }
            }
            setLoading(false);
        });
    };

    const refreshDrives = (type) => {
        const payload = {
            ...(type === "folders" ? { folders_page: 1 } : { sheets_page: 1 }),
            ...(id ? { team_id: id } : {}),
            ...buildQueryParams(filters, activeTab),

        };


        fetchApiFunc(payload, (response) => {
            if (response?.status === true) {
                response?.team_name && setTeamName(response?.team_name);
                if (type === "folders") {
                    setFolderCount(response?.folders?.count);
                    setFolders(response?.folders?.data || []);
                    setFolderPage(1);
                } else {
                    setSheetCount(response?.sheets?.count);
                    setSheets(response?.sheets?.data || []);
                    setSheetPage(1);
                }
            }
        });
    }

    const resetAndFetchFoldersAndSheets = (folderId) => {
        setFolders([]);
        setSheets([]);
        setLoading(true);

        const params = buildQueryParams(filters, activeTab);

        fetchSingleDriveApiFunc(folderId, params, (response) => {
            if (response) {
                setFolders(response?.folder?.subfolders || []);
                setFolderCount(response?.folders?.count || 0);
                setSheets(response?.folder?.sheets || []);
                setSheetCount(response?.sheets?.count || 0);
            }
            setLoading(false);
        });
    };

    const refreshFoldersAndSheets = (folderId) => {
        setLoading(true);

        const params = buildQueryParams(filters, activeTab);

        fetchSingleDriveApiFunc(folderId, params, (response) => {
            if (response) {
                setFolders(response?.folder?.subfolders || []);
                setFolderCount(response?.folders?.count || 0);
                setSheets(response?.folder?.sheets || []);
                setSheetCount(response?.sheets?.count || 0);
            }
            setLoading(false);
        });
    };


    const enterFolder = (folder) => {
        setCurrentFolderId(folder.id);

        const existingIndex = breadcrumb.findIndex(b => b.id === folder.id);
        let newBreadcrumb;
        if (existingIndex !== -1) {
            newBreadcrumb = breadcrumb.slice(0, existingIndex + 1);
        } else {
            newBreadcrumb = [...breadcrumb, { id: folder.id, name: folder.name }];
        }

        setBreadcrumb(newBreadcrumb);
        localStorage.setItem("breadcrumb", JSON.stringify(newBreadcrumb));

        resetAndFetchFoldersAndSheets(folder.id);
    };


    const handleBreadcrumbClick = (index) => {
        const folder = breadcrumb[index];
        setCurrentFolderId(folder.id);
        const newBreadcrumb = breadcrumb.slice(0, index + 1);
        setBreadcrumb(newBreadcrumb);
        localStorage.setItem("breadcrumb", JSON.stringify(newBreadcrumb));

        if (folder.id === null) {
            resetAndFetch("folders");
            resetAndFetch("files");
            setActiveTab('folders')
        } else {
            resetAndFetchFoldersAndSheets(folder.id);
        }
    };

    useEffect(() => {
        const { searchQuery, highlightType } = location.state || {};
        if (searchQuery) {
            setFilters(prev => ({ ...prev, search: searchQuery }));
            setCurrentFolderId(null);
            setBreadcrumb([{ id: null, name: "Home" }]);
            if (highlightType === 'folder') {
                setActiveTab('folders');
            } else if (highlightType === 'sheet') {
                setActiveTab('files');
            }
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.state, navigate]);


    useEffect(() => {
        if (location.state?.searchQuery) return;

        const lastCrumb = breadcrumb[breadcrumb.length - 1];
        if (!lastCrumb) return;

        const folderId = lastCrumb.id ?? "root";

        if (
            lastFetchRef.current.folderId === folderId &&
            lastFetchRef.current.filtersKey === filterKey
        ) {
            return;
        }

        lastFetchRef.current = {
            folderId,
            filtersKey: filterKey
        };

        if (lastCrumb.id === null) {
            resetAndFetch("folders");
            resetAndFetch("files");
        } else {
            resetAndFetchFoldersAndSheets(lastCrumb.id);
        }

    }, [breadcrumb, filterKey]);



    useEffect(() => {
        if (breadcrumb.length > 0) {
            localStorage.setItem("breadcrumb", JSON.stringify(breadcrumb));
        } else {
            localStorage.removeItem("breadcrumb");
        }
    }, [breadcrumb]);

    const resetAndFetch = (type) => {
        if (type === "folders") {
            setFolders([]);
            setFolderPage(1);
            fetchDrives(1, "folders");
        } else {
            setSheets([]);
            setSheetPage(1);
            fetchDrives(1, "files");
        }
    };

    const handleObserver = useCallback(
        (entries) => {
            const target = entries[0];
            if (target.isIntersecting && !loading) {
                if (activeTab === "folders" && folders?.length < folderCount) {
                    const nextPage = folderPage + 1;
                    setFolderPage(nextPage);
                    fetchDrives(nextPage, "folders");
                }
                if (activeTab === "files" && sheets?.length < sheetCount) {
                    const nextPage = sheetPage + 1;
                    setSheetPage(nextPage);
                    fetchDrives(nextPage, "files");
                }
            }
        },
        [loading, activeTab, folderPage, sheetPage, folders.length, sheets.length, folderCount, sheetCount]
    );

    useEffect(() => {
        const option = { root: null, rootMargin: "20px", threshold: 1.0 };
        const observer = new IntersectionObserver(handleObserver, option);

        if (loaderRef.current) observer.observe(loaderRef.current);

        return () => {
            if (loaderRef.current) observer.unobserve(loaderRef.current);
        };
    }, [handleObserver]);



    const handleCheckboxChange = (itemId) => {
        setSelectedIds(prev => {
            if (prev.includes(itemId)) {
                return prev.filter(id => id !== itemId);
            } else {
                return [...prev, itemId];
            }
        });
    };

    const handleSelectAll = () => {
        if (selectedIds.length === sheets.length) {
            setSelectedIds([]);
        } else {
            setSelectedIds(sheets.map(item => item.id));
        }
    };

    const isAllSelected = sheets?.length > 0 && selectedIds.length === sheets.length;
    const isSomeSelected = selectedIds.length > 0 && selectedIds.length < sheets?.length;

    const handleDownload = () => {
        if (selectedIds.length > 0) {
            downloadToCsv({ sheet_ids: selectedIds }, () => {
            });
        }
    }

    const handleBulkDelete = () => {
        setLoading(true);
        if (selectedIds.length > 0) {
            bulkDeleteSheets({ sheet_ids: selectedIds }, (res) => {
                if (res?.status === true) {
                    ReactNotifications(res?.message || res?.data?.message, utilConstants.sucessState200);
                    currentFolderId === null
                        ? resetAndFetch("files")
                        : resetAndFetchFoldersAndSheets(currentFolderId)
                    setShowDeleteModal(false);
                    setSelectedIds([]);
                }
                setLoading(false);
            });
        }
    }

    const handleSheetSave = () => {
        setLoadingSheetId(null);
        if (currentFolderId === null) {
            refreshDrives("files");
        } else {
            refreshFoldersAndSheets(currentFolderId);
        }
    }

    const handleFilterChange = useCallback((filterName, value) => {
        setSelectedIds([]);
        setFilters(prev => ({
            ...prev,
            [filterName]: value
        }));
    }, []);

    useEffect(() => {
        setPageTitle('Drive');
    }, [setPageTitle]);



    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
            </div>
        );
    }

    return (
        <div className="mt-2">
            <div className="px-2 flex items-center justify-between sticky top-[65px] bg-white z-20">

                <div className="flex flex-row items-center ml-[17px]">
                    <h2 className="flex font-bold text-xl !m-0">{teamName ? teamName + " Team Drive" : headingTitle}</h2>
                    <div className="ml-[20px]">
                        {breadcrumb?.length > 1 && (
                            <div className="px-1 py-1 flex flex-wrap items-center gap-1 bg-white sticky top-[120px] z-10 text-sm mr-6">
                                {breadcrumb?.map((b, idx) => (
                                    <div key={b?.id} className="flex items-center">
                                        <span
                                            className={`cursor-pointer px-2 py-1 rounded-md transition ${idx === breadcrumb?.length - 1
                                                ? "text-gray-900 font-semibold bg-gray-100"
                                                : "text-blue-600 hover:underline hover:text-blue-800"
                                                }`}
                                            onClick={() => handleBreadcrumbClick(idx)}
                                        >
                                            {b?.name === "Home" ? (
                                                <FaHome size={21} className="inline-block text-black" />
                                            ) : (
                                                b?.name
                                            )}
                                        </span>
                                        {idx < breadcrumb?.length - 1 && (
                                            <BiChevronRight size={24} className="text-gray-400 mx-1" />
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {isAddEdit && <div className="flex !mr-[10px] p-1">
                    {/* <Button className="d-flex !rounded-sm px-2 py-1 !bg-[#AEF468] !border-none text-black" > */}
                    <AddButtonMenu handleOpenModal={() => handleOpenModal('add')}
                        setActiveTab={setActiveTab}
                    />
                    {/* </Button> */}

                </div>}
            </div>

            <div className="border-b mr-6 ml-6 sticky top-[120px] bg-white z-10"></div>


            <div className="flex flex-col gap-4 sm:flex-row sm:justify-between sm:items-center ml-6 mr-6 mt-3 sticky top-[103px] bg-white z-10 overflow-hidden">
                <div className="flex bg-[#F6F6F6] rounded-sm p-1">
                    <button
                        className={`px-4 py-2 text-sm font-medium rounded-sm ${activeTab === "folders" ? "bg-white shadow" : "bg-transparent"
                            }`}
                        onClick={() => setActiveTab("folders")}
                    >
                        Folders
                    </button>
                    <button
                        className={`px-4 py-2 text-sm font-medium rounded-sm ${activeTab === "files" ? "bg-white shadow" : "bg-transparent"
                            }`}
                        onClick={() => setActiveTab("files")}
                    >
                        Files
                    </button>
                </div>
                <div>
                    {selectedIds?.length > 0 && (
                        <div className="flex gap-2">
                            <div
                                className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3  py-1 bg-white hover:bg-gray-50 border-2 border-gray-800 rounded-lg shadow-lg cursor-pointer transition-all duration-200 hover:shadow-xl"
                                onClick={handleDownload}
                            >
                                <FaFileExport size={15} className="text-gray-700 sm:w-[20px] sm:h-[20px]" />
                                <span className="font-medium text-gray-800 text-sm sm:text-base xs:inline">Export ({selectedIds?.length})</span>
                            </div>
                            <div
                                className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3  py-1 bg-white hover:bg-gray-50 border-2 border-red-800 rounded-lg shadow-lg cursor-pointer transition-all duration-200 hover:shadow-xl"
                                onClick={() => setShowDeleteModal(true)}
                            >
                                <FaTrash size={15} className="text-red-700 sm:w-[20px] sm:h-[20px]" />
                                <span className="font-medium text-red-800 text-sm sm:text-base xs:inline">Delete ({selectedIds?.length})</span>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className="px-6 mt-4">
                <FilterComponent
                    activeTab={filters.type}
                    onTabChange={(tab) => handleFilterChange("type", tab)}
                    sortBy={filters.sortBy}
                    onSortChange={(key) => handleFilterChange("sortBy", key)}
                    onDateChange={(date) => handleFilterChange("date", date)}
                    showTabs={activeTab === "files"}
                    selectedDate={filters.date}
                />
            </div>

            {activeTab === "folders" && (
                <>
                    {folders?.length > 0 && !loading ? (
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 px-4 sm:px-6 mt-4 mb-3">
                            {folders?.map((item, index) => (
                                <div
                                    key={index}
                                    id={`folder-${item.id}`}
                                    className="border rounded-lg shadow-sm flex flex-col hover:shadow-md transition bg-white"
                                >
                                    <div className="flex justify-between py-2 px-3 mt-[3px] bg-[#F6F6F6] rounded-t-lg">
                                        <h4 className="font-medium text-gray-800 text-sm sm:text-base truncate flex-1 mr-2">
                                            {item?.name}
                                        </h4>
                                        <span className="font-normal text-xs sm:text-sm text-gray-600 whitespace-nowrap">
                                            {item?.subfolders?.length > 0 && `${item.subfolders.length} ${item.subfolders.length === 1 ? 'Folder' : 'Folders'}`}
                                            {item?.subfolders?.length > 0 && item?.sheets?.length > 0 && ' • '}
                                            {item?.sheets?.length > 0 && `${item.sheets.length} ${item.sheets.length === 1 ? 'File' : 'Files'}`}
                                            {(!item?.subfolders?.length && !item?.sheets?.length) && 'Empty'}
                                        </span>
                                    </div>

                                    <div
                                        className="flex justify-center items-center w-full py-6 cursor-pointer"
                                        onClick={() => enterFolder(item)}
                                    >
                                        <img
                                            src={folderImg}
                                            alt="Folder"
                                            className="w-32 h-24 sm:w-40 sm:h-28 md:w-44 md:h-32 object-contain"
                                        />
                                    </div>

                                    <div className="flex !items-center justify-between px-3 py-2 border-t">
                                        {/* Last Opened Date */}
                                        <div className="flex items-center gap-2 flex-1 min-w-0">
                                            {/* <div className="w-8 h-8 rounded-full bg-pink-500 flex items-center justify-center text-white font-semibold text-sm flex-shrink-0">
                                    {item?.user_name ? item.user_name.charAt(0).toUpperCase() : 'G'}
                                </div> */}
                                            <span className="text-xs sm:text-sm text-gray-600 truncate">
                                                {item?.last_opened_at
                                                    ? `Opened: ${new Date(item.last_opened_at).toLocaleDateString('en-GB', {
                                                        day: 'numeric',
                                                        month: 'short',
                                                        year: 'numeric'
                                                    })}`
                                                    : 'Not opened yet'
                                                }
                                            </span>
                                        </div>


                                        <div className="flex-shrink-0">
                                            <Menu
                                                item={item}
                                                fetchAllPersonalDrives={currentFolderId === null ? () => resetAndFetch("folders") : () => resetAndFetchFoldersAndSheets(currentFolderId)}
                                                handleOpenModal={handleOpenModal}
                                                deleteApiFunc={deleteFolder}
                                                type={"folder"}
                                                isAddEdit={isAddEdit}
                                            />
                                        </div>

                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="flex justify-center items-center w-full mt-10">
                            <NoData title="Folders" />
                        </div>
                    )}
                </>
            )}

            {activeTab === "files" && (
                <>
                    {sheets?.length > 0 && !loading ? (
                        <div className="px-4 sm:px-6 mt-4 mb-3 w-full">
                            <div className="hidden md:grid grid-cols-[auto_1fr_1fr_1fr_1fr_1fr_1fr_auto] gap-4 text-sm font-semibold text-gray-600 border-b pb-2">
                                <div className="flex items-center">
                                    <input
                                        type="checkbox"
                                        checked={isAllSelected}
                                        ref={input => {
                                            if (input) {
                                                input.indeterminate = isSomeSelected;
                                            }
                                        }}
                                        onChange={handleSelectAll}
                                        className="h-4 w-4 rounded border-gray-300 cursor-pointer accent-[#AEF468]"
                                        style={{ accentColor: '#AEF468' }}
                                    />
                                </div>
                                <span>File Name</span>
                                <span>Owned by</span>
                                <span>Type</span>
                                <span>File Size</span>
                                <span>Last Updated</span>
                                <span></span>
                            </div>

                            <div className="divide-y">
                                {sheets.map((item, index) => (
                                    <div
                                        key={index}
                                        id={`sheet-${item.id}`}
                                        className="grid grid-cols-1 md:grid-cols-[auto_1fr_1fr_1fr_1fr_1fr_1fr_auto] gap-3 md:gap-4 py-3 items-start md:items-center text-sm hover:bg-gray-50 cursor-pointer"
                                        onClick={() => {
                                            setLoadingSheetId(item.id);
                                            tableRef.current.handleClick(item, item.id, "personal")
                                            setCurrentSheetIndex(item.id)
                                        }}
                                    >
                                        <div
                                            className="hidden md:flex items-center"
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={selectedIds.includes(item.id)}
                                                onChange={() => handleCheckboxChange(item.id)}
                                                className="h-4 w-4 rounded border-gray-300 rounded-lg cursor-pointer accent-[#AEF468]"
                                                style={{ accentColor: '#AEF468' }}
                                            />
                                        </div>

                                        <div className="flex items-center gap-2">
                                            <div className="flex md:hidden items-center mr-2">
                                                <input
                                                    type="checkbox"
                                                    checked={selectedIds.includes(item.id)}
                                                    onChange={() => handleCheckboxChange(item.id)}
                                                    onClick={(e) => e.stopPropagation()}
                                                    className="h-4 w-4 text-blue-600 rounded border-gray-300 cursor-pointer"
                                                />
                                            </div>
                                            {loadingSheetId === item.id ? (
                                                <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-gray-900"></div>
                                            ) : (
                                                <FaFileAlt className="text-[#8BA4BD] h-6 w-6 shrink-0" />
                                            )}
                                            <span className="truncate font-medium text-gray-800">
                                                {item?.title}
                                            </span>
                                        </div>

                                        <div className="flex md:block">
                                            <span className="md:hidden font-semibold text-gray-500 mr-2">Owned by:</span>
                                            <span className="text-gray-600">
                                                {item?.user_first_name + " " + item?.user_last_name}
                                            </span>
                                        </div>

                                        <div className="flex md:block">
                                            <span className="md:hidden font-semibold text-gray-500 mr-2">Type:</span>
                                            <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs">
                                                {item?.is_shared ? "shared" : "unshared"}
                                            </span>
                                        </div>

                                        <div className="flex md:block">
                                            <span className="md:hidden font-semibold text-gray-500 mr-2">File Size:</span>
                                            <span className="text-gray-600">
                                                {formatFileSize(item?.size)}
                                            </span>
                                        </div>

                                        <div className="flex md:block">
                                            <span className="md:hidden font-semibold text-gray-500 mr-2">Last Updated:</span>
                                            <span className="text-gray-600">{timeAgo(item?.updated_at)}</span>
                                        </div>

                                        <div
                                            className="flex justify-end"
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            {isAddEdit && (
                                                <Menu
                                                    item={item}
                                                    fetchAllPersonalDrives={
                                                        currentFolderId === null
                                                            ? () => resetAndFetch("files")
                                                            : () => resetAndFetchFoldersAndSheets(currentFolderId)
                                                    }
                                                    handleOpenModal={handleOpenModal}
                                                    deleteApiFunc={deleteFile}
                                                    type={"file"}
                                                />
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div className="flex justify-center items-center w-full mt-10">
                            <NoData title="Files" />
                        </div>
                    )}
                </>
            )}

            {(activeTab === "folders" ? folders?.length < folderCount : sheets?.length < sheetCount) && (
                <div ref={loaderRef} className="flex justify-center py-4">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
                </div>
            )}

            <Sheet ref={tableRef} onSave={handleSheetSave} />

            <CommonModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                handleSave={handleSave}
                mode={modalMode}
                columns={
                    activeTab === "files"
                        ? fileColumns
                        : folderColumns
                }
                data={modalData}
                handleChange={handleChange}
                errors={errors}
                saveButtonText={modalMode === 'add' ? "Add" : "Update"}
                isSaving={isSaving}
            />

            <DeleteModal
                show={showDeleteModal}
                isLoading={loading}
                onClose={() => setShowDeleteModal(false)}
                onConfirm={handleBulkDelete}
                message={`Are you sure you want to delete ${selectedIds?.length > 1 ? `${selectedIds.length} sheets` : 'this sheet'}?`}
            />
        </div>
    );
};

export default PersonalDrive;